import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** The Tickethead SDK instance injected by plugins/axios.ts. */
export function useSdk(): Vue['$sdk'] {
  return resolveInjected('$sdk');
}
